import { ActionType, ComponentType } from '../../enums';

export interface createAccordionOpenEventPayloadOptions {
  groupName: string;
  itemName: string;
}

export interface createAccordionOpenEventPayloadReturn {
  event_data: {
    action: ActionType;
    component_type: ComponentType;
    group_name: string;
    item_name: string;
  };
}

export const createAccordionOpenEventPayload = ({
  groupName,
  itemName,
}: createAccordionOpenEventPayloadOptions): createAccordionOpenEventPayloadReturn => ({
  event_data: {
    action: ActionType.OPEN,
    component_type: ComponentType.ACCORDION,
    group_name: groupName,
    item_name: itemName,
  },
});
